export const classes = {
  logo: 'block h-[38px] w-auto text-[#16243d] dark:text-[#eef0f7]',
};
